export enum PageCategory {
  Assessments = 'Assessments',
  Catalog = 'Catalog',
  Collection = 'Collection',
  Checkout = 'Checkout',
  PaidProgram = 'Paid Program',
  FreeProgram = 'Free Program',
  Home = 'Home',
  Dashboard = 'Dashboard',
  Uncategorized = 'Uncategorized',
  School = 'School',
  PersonalizedDiscount = 'Personalized Discount',
  WelcomeFlow = 'Welcome Flow',
  GetStarted = 'Get Started',
  Plans = 'Plans',
  Legal = 'Legal',
  Experience = 'Experience',
  Scholarship = 'Scholarship',
  CaseStudy = 'Case Study',
  EnterpriseEbook = 'Enterprise Ebook',
  EnterpriseInfographic = 'Enterprise Infographic',
  EnterpriseReport = 'Enterprise Report',
  EnterpriseWebinar = 'Enterprise Webinar',
  EnterpriseLiveEvent = 'Enterprise Live Event',
  EnterpriseVideo = 'Enterprise Video',
  EnterpriseResourceCenter = 'Enterprise Resource Center',
  Skills = 'Skills',
  ACIResource = 'ACI Resource',
  Topic = 'Topic',
  Subcategory = 'Subcategory',
  Syllabus = 'Syllabus',
  LearningPlanLanding = 'Learning Plan Landing',
  Enrollment = 'Enrollment',
  Government = 'Government',
}

export const UDACITY_SEGMENT_PROXY_URL = 'https://sgmt.udacity.com/api/v1';
export const SEGMENT_URL = 'https://api.segment.io/v1';
